import keyBy from 'lodash/keyBy';
import max from 'lodash/max';
import omit from 'lodash/omit';

function getFieldsToRemove() {
  return [
    'id',
    'created',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
    'contentType',
    'objectId',
    'changeRequest',

    'replies',
  ];
}

export function transformForPatch(model) {
  return omit(model, getFieldsToRemove());
}

// This update function assumes that there is at most one level of nesting within the comments tree
export function replaceOrPush(initialList, updates, replies = false) {
  return updates.reduce((list, update) => {
    const existingIdx = list.findIndex(
      item => item.id === update.id || item.id === update.parentId,
    );
    if (existingIdx >= 0) {
      const existing = initialList[existingIdx];
      return [].concat(
        list.slice(0, existingIdx),
        existing.id === update.id
          ? { ...update, replies: existing.replies }
          : {
              ...existing,
              replies: replaceOrPush(existing.replies, [update], true),
            },
        list.slice(existingIdx + 1),
      );
    }
    return replies
      ? list.concat({ ...update, replies: [] })
      : [{ ...update, replies: [] }].concat(list);
  }, initialList);
}

// This function also sorts comments form newest to oldest
export function nest(allComments, parentId = null, sort = true) {
  const sortedComments = sort
    ? allComments.sort((a, b) => new Date(b.created) - new Date(a.created))
    : allComments.sort((a, b) => new Date(a.created) - new Date(b.created));
  return sortedComments
    .filter(comment => comment.parentId === parentId)
    .map(comment => ({
      ...comment,
      replies: nest(allComments, comment.id, false),
    }));
}

export function removeChangeRequests(allComments) {
  return allComments.map(comment => omit(comment, 'changeRequest'));
}

export function collectMembers(users) {
  const teamsByName = {};
  users.forEach(user => {
    if (!teamsByName[user.team]) {
      teamsByName[user.team] = { members: [] };
    }
    teamsByName[user.team].members.push(user.id);
  });
  return teamsByName;
}

export function getLatestTimestamp(comments) {
  const newestCommentTimestamp = comments.reduce(
    (acc, comment) =>
      max([comment.lastModified, acc, getLatestTimestamp(comment.replies)]),
    new Date(0).toISOString(),
  );
  return newestCommentTimestamp;
}

export function collectChangeRequests(allComments) {
  return keyBy(
    allComments.filter(c => c.changeRequest).map(c => c.changeRequest),
    'commentId',
  );
}
